<div align="center">
   <img src="assets/404.jpg" alt="" />
</div>
